module.exports = __webpack_public_path__ + "static/media/firstam_philip_clark.d5bc3809.jpg";